var _desc, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93.75,
    height: 99.125,
    viewBox: "0 0 93.75 99.125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 46.875,
    y1: -2.859374,
    x2: 46.875,
    y2: 100.087654,
    id: "paint_linear_640_232_0",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#031634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CDA407"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M93.75 61C93.75 51.86 87.96 44.09 79.93 41.22L81.08 31.51C81.51 28.71 84.37 26.68 86.25 26.68L90 26.68L90 20.96C90 15.71 85.79 11.43 80.62 11.43L59.47 11.43L57.86 6.54C56.58 2.62 53 0 48.94 0L41.05 0C37 0 33.41 2.62 32.13 6.54L30.52 11.43L9.37 11.43C4.2 11.43 0 15.71 0 20.96L0 26.68L3.75 26.68C5.62 26.68 8.48 28.71 8.91 31.51L17.77 91.07C18.49 95.74 22.39 99.12 27.03 99.12L62.96 99.12C67.6 99.12 71.5 95.74 72.22 91.07L73.64 81.94C84.77 81.65 93.75 72.38 93.75 61ZM35.68 7.74C36.45 5.39 38.61 3.81 41.05 3.81L48.94 3.81C51.38 3.81 53.54 5.39 54.31 7.74L55.52 11.43L51.97 11.43L50.95 8.32C50.44 6.76 49.01 5.71 47.4 5.71L42.59 5.71C40.98 5.71 39.55 6.76 39.04 8.31L38.02 11.43L34.47 11.43L35.68 7.74ZM3.75 20.96C3.75 17.81 6.27 15.25 9.37 15.25L36.77 15.25L53.22 15.25L80.62 15.25C83.72 15.25 86.25 17.81 86.25 20.96L86.25 22.87L3.75 22.87L3.75 20.96ZM68.52 90.48C68.08 93.28 65.75 95.31 62.96 95.31L55.53 95.31L54.69 93.61C54.05 92.31 52.76 91.5 51.33 91.5L38.66 91.5C37.23 91.5 35.94 92.31 35.3 93.61L34.46 95.31L27.03 95.31C24.25 95.31 22.1 93.28 21.67 90.48L12.62 30.92C12.37 29.32 11.67 27.89 10.74 26.68L18.75 26.68L18.75 36.21L22.5 36.21L22.5 26.68L28.12 26.68L28.12 47.65L31.87 47.65L31.87 26.68L37.5 26.68L37.5 41.93L41.25 41.93L41.25 26.68L46.87 26.68L46.87 36.21L50.62 36.21L50.62 26.68L79.25 26.68C78.32 27.89 77.62 29.32 77.37 30.92L76.26 40.3C75.24 40.13 74.19 40.03 73.12 40.03C61.75 40.03 52.5 49.43 52.5 61L52.5 81.96L69.84 81.96L68.52 90.48ZM73.12 78.15L56.25 78.15L56.25 61C56.25 51.54 63.82 43.84 73.12 43.84C82.42 43.84 90 51.54 90 61C90 70.45 82.42 78.15 73.12 78.15Z",
    fill: "url(#paint_linear_640_232_0)",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBag);
export default __webpack_public_path__ + "static/media/TrashBag.a669db73c97341358bd1e15eda30bdcf.svg";
export { ForwardRef as ReactComponent };